/*
 * Real outlined SVG icons — single consistent family, 1.6px stroke (Design
 * System v1.0 Icon System). Never emoji, never placeholder dots, no fills
 * except the sparkle (AI moments) and status dots.
 */
const base = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
}

function Svg({ size = 20, children, ...rest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" {...base} {...rest}>
      {children}
    </svg>
  )
}

/* Flow wave mark (wordmark glyph) */
export function FlowMark({ size = 15 }) {
  return (
    <Svg size={size} viewBox="0 0 24 24">
      <path d="M2 9c2.5 0 2.5 4 5 4s2.5-4 5-4 2.5 4 5 4 2.5-4 5-4" />
      <path d="M2 15c2.5 0 2.5 4 5 4s2.5-4 5-4" opacity="0.5" />
    </Svg>
  )
}

export function Building({ size }) {
  return (
    <Svg size={size}>
      <path d="M6 21V5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v16" />
      <path d="M14 9h3a1 1 0 0 1 1 1v11" />
      <path d="M3 21h18" />
      <path d="M9 8h2M9 12h2M9 16h2" />
    </Svg>
  )
}

export function ArrowRight({ size }) {
  return (
    <Svg size={size}>
      <path d="M5 12h14" />
      <path d="M13 6l6 6-6 6" />
    </Svg>
  )
}

export function Check({ size }) {
  return (
    <Svg size={size}>
      <path d="M5 13l4 4L19 7" />
    </Svg>
  )
}

export function Pin({ size }) {
  return (
    <Svg size={size}>
      <path d="M12 21s7-5.5 7-11a7 7 0 1 0-14 0c0 5.5 7 11 7 11Z" />
      <circle cx="12" cy="10" r="2.5" />
    </Svg>
  )
}

export function Wave({ size }) {
  return (
    <Svg size={size}>
      <path d="M7 11V6.5a1.5 1.5 0 0 1 3 0V10" />
      <path d="M10 10V5a1.5 1.5 0 0 1 3 0v5" />
      <path d="M13 10.5V6.5a1.5 1.5 0 0 1 3 0V13" />
      <path d="M16 9.5a1.5 1.5 0 0 1 3 0v3.5a7 7 0 0 1-7 7 6.5 6.5 0 0 1-5.2-2.6L4 14.5a1.6 1.6 0 0 1 2.3-2.2L8 14" />
    </Svg>
  )
}

export function Camera({ size }) {
  return (
    <Svg size={size}>
      <path d="M4 8a2 2 0 0 1 2-2h1.5l1-1.5h5l1 1.5H18a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z" />
      <circle cx="12" cy="12.5" r="3.2" />
    </Svg>
  )
}

export function Alert({ size }) {
  return (
    <Svg size={size}>
      <path d="M12 3.5 21 19H3Z" />
      <path d="M12 10v4" />
      <path d="M12 17h.01" />
    </Svg>
  )
}

export function QrScan({ size }) {
  return (
    <Svg size={size}>
      <path d="M4 8V5a1 1 0 0 1 1-1h3" />
      <path d="M20 8V5a1 1 0 0 0-1-1h-3" />
      <path d="M4 16v3a1 1 0 0 0 1 1h3" />
      <path d="M20 16v3a1 1 0 0 1-1 1h-3" />
      <path d="M4 12h16" />
    </Svg>
  )
}

export function User({ size }) {
  return (
    <Svg size={size}>
      <circle cx="12" cy="8" r="3.5" />
      <path d="M5 20a7 7 0 0 1 14 0" />
    </Svg>
  )
}

export function Users({ size }) {
  return (
    <Svg size={size}>
      <circle cx="9" cy="8" r="3" />
      <path d="M3.5 19a5.5 5.5 0 0 1 11 0" />
      <path d="M16 5.5a3 3 0 0 1 0 5.8" />
      <path d="M17 13.5a5.5 5.5 0 0 1 3.5 5" />
    </Svg>
  )
}

export function CloudOff({ size }) {
  return (
    <Svg size={size}>
      <path d="M7 18a4 4 0 0 1-.8-7.9A5 5 0 0 1 15 8" />
      <path d="M16.5 9A3.5 3.5 0 0 1 18 18H9" />
      <path d="M3 3l18 18" />
    </Svg>
  )
}

/* Sparkle — the AI-moment marker, cyan, deliberately rare. Filled by design. */
export function Sparkle({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true"
         fill="var(--cyan)" stroke="none">
      <path d="M12 2l1.6 5.4L19 9l-5.4 1.6L12 16l-1.6-5.4L5 9l5.4-1.6Z" />
      <path d="M18.5 14l.8 2.6 2.7.9-2.7.9-.8 2.6-.8-2.6-2.7-.9 2.7-.9Z" opacity="0.85" />
    </svg>
  )
}
